import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const companiesListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    component: lazyRouteComponent(() => import('./CompaniesList'))
  })
